import { render, staticRenderFns } from "./CommunicationGroupings.vue?vue&type=template&id=c4ba34a8&scoped=true&"
import script from "./CommunicationGroupings.vue?vue&type=script&lang=js&"
export * from "./CommunicationGroupings.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationGroupings.vue?vue&type=style&index=0&id=c4ba34a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ba34a8",
  null
  
)

export default component.exports